const defaultArray = [];

export const getPartners = ({ partners: { partners = defaultArray } }) => partners;
